import { http } from "./http";

/** Présence d'une personne dans la messagerie : en ligne, et l'heure de son dernier signal. */
export type Presence = {
  online: boolean;
  /** Dernier signal, `null` si inconnu (jamais vu, ou présence d'un groupe). */
  lastSeenAt: string | null;
};

export const presenceApi = {
  /** Signal du compte connecté : l'application est ouverte et utilisée. */
  heartbeat: async () => {
    await http.post("/v1/presence/heartbeat");
  },
};
